// #region Mock de Caixa & Movimentos
let _caixas = [
  {
    id: 1,
    data_referencia: '2024-01-19',
    data_abertura: '2024-01-19T08:00:00',
    data_fechamento: '2024-01-19T18:00:00',
    valor_inicial: 200,
    valor_estimado: 1195.50,
    valor_real: 1195.50,
    status: 'FECHADO_MANUAL',
    observacoes: 'Fechado manualmente sem divergências',
    total_entradas: 1395.50,
    total_saidas: 200.00,
  },
  {
    id: 2,
    data_referencia: '2024-01-20',
    data_abertura: '2024-01-21T08:00:00',
    data_fechamento: null,
    valor_inicial: 200,
    valor_estimado: 980.00,
    valor_real: null,
    status: 'ABERTO',
    observacoes: 'Aberto automaticamente',
    total_entradas: 1180.00,
    total_saidas: 200.00,
  },
  {
    id: 3,
    data_referencia: '2024-01-18',
    data_abertura: '2024-01-19T08:00:00',
    data_fechamento: '2024-01-19T18:30:00',
    valor_inicial: 200,
    valor_estimado: 1089.75,
    valor_real: 1089.75,
    status: 'FECHADO_AUTO',
    observacoes: 'Auto-fechado na virada de dia',
    total_entradas: 1289.75,
    total_saidas: 200.00,
  },
];

let _movimentos = [
  { id: 1, caixa_id: 1, pagamento_id: 10, tipo: 'ENTRADA', valor: 150.00, descricao: 'Venda #10', data_hora: '2024-01-19T09:12:00' },
  { id: 2, caixa_id: 1, pagamento_id: 11, tipo: 'SAIDA', valor: 50.00, descricao: 'Reembolso parcial', data_hora: '2024-01-19T10:30:00' },
  { id: 3, caixa_id: 2, pagamento_id: 12, tipo: 'ENTRADA', valor: 780.00, descricao: 'Venda #11', data_hora: '2024-01-20T11:45:00' },
];
// #endregion

// #region Utils
const delay = (ms = 200) => new Promise(r => setTimeout(r, ms));
// #endregion

// #region Métodos Caixa
export async function listCaixas() {
  await delay();
  return _caixas.map(c => ({ ...c }));
}

export async function getCaixa(id) {
  await delay();
  const f = _caixas.find(c => c.id === id);
  return f ? { ...f } : null;
}

export async function createCaixa(payload) {
  await delay();
  const id = Date.now();
  const novo = {
    id,
    status: 'ABERTO',
    valor_real: null,
    valor_estimado: payload.valor_inicial,
    total_entradas: payload.valor_inicial,
    total_saidas: 0,
    ...payload,
  };
  _caixas = [novo, ..._caixas];
  return { ...novo };
}

export async function fecharCaixa(id, { valor_real, manual = false } = {}) {
  await delay();
  let updated = null;
  _caixas = _caixas.map(c => {
    if (c.id === id) {
      updated = {
        ...c,
        valor_real: valor_real ?? c.valor_estimado,
        status: manual ? 'FECHADO_MANUAL' : 'FECHADO_AUTO',
        data_fechamento: new Date().toISOString(),
      };
      return updated;
    }
    return c;
  });
  return updated ? { ...updated } : null;
}
// #endregion

// #region Métodos Movimentos
export async function listMovimentosByCaixa(caixaId) {
  await delay();
  return _movimentos
    .filter(m => m.caixa_id === caixaId)
    .map(m => ({ ...m }));
}

export async function addMovimento(caixaId, payload) {
  await delay();
  const id = Date.now();
  const mov = { id, caixa_id: caixaId, pagamento_id: payload.pagamento_id || null, ...payload };
  _movimentos = [mov, ..._movimentos];
  // sumariza agregados
  _caixas = _caixas.map(c => {
    if (c.id === caixaId) {
      if (mov.tipo === 'ENTRADA') {
        c.total_entradas += mov.valor;
        c.valor_estimado += mov.valor;
      } else {
        c.total_saidas += mov.valor;
        c.valor_estimado -= mov.valor;
      }
      return { ...c };
    }
    return c;
  });
  return { ...mov };
}
// #endregion

// #region Export
const caixaApi = { listCaixas, getCaixa, createCaixa, fecharCaixa, listMovimentosByCaixa, addMovimento };
export default caixaApi;
// #endregion
